import NodeDropPoints from "./NodeDropPoints";
import { useContext, useState, useEffect } from 'react';
import A from './ActionCreators';
import { useDispatch } from 'react-redux';
import EditableContent from './EditableContent';
import { MouseAvailabilityContext } from './MouseFocusProvider';
import NodeWrapper from './NodeWrapper';


export default function ExpansionTextItem({
  node,
  nodeId,
  selected,
  label,
  textStyle,
  onEvent,
}){

  let [editing,setEditing] = useState(false);
  let [tempValue,setTempValue] = useState(label);

  //const { requestMouseFocus, releaseMouseFocus } = useContext(MouseAvailabilityContext);


  if( editing ){
    let onFinishedEditing = (value) => {
      onEvent && onEvent({
        type:"setLabel",
        itemType:"expansionNode",
        //event:e,
        node,
        nodeId,
        value
      })

      setEditing(false);
    }
    

    return (
      <EditableContent nodeId={nodeId} 


        class="sg-col"

        editable={editing}
        onEnter={onFinishedEditing}
        onBlur={onFinishedEditing}

        onChange={value => {
          //setTempValue(value)
        }}

        content={label}
        style={{
          ...textStyle,
          position:'relative',
          pointerEvents:'auto',
          //border:'3px solid blue',
        }}
        focusOnRender={true}

      />
    )
  }else{


    let onSomeClick = e => {

      e.stopPropagation();
      e.preventDefault();

      onEvent && onEvent({
        type:e.type,
        itemType:"expansionNode",
        event:e,
        node,
        nodeId,
      })
      //onItemClick && onItemClick(nodeId);

    }

    return (
      <div component="text" nodeId={nodeId} 
        //onClick={onSomeClick} 
        onContextMenu={onSomeClick}
        class="sg-col"

        onMouseDown={() => {

          //requestMouseFocus(nodeId)
        }}
        onMouseUp={() => {
          //releaseMouseFocus(nodeId);
        }}

        onDoubleClick={() => {
          setEditing(true)
        }}

        style={{

          fontFamily:'Helvetica',
          ...textStyle,
          position:'relative',
          padding:2,
          
          top:0,
          left:0,
          pointerEvents:'auto',
          lineHeight:1,
        }}>
        {label}
      </div>
    )
  }
}
